import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Button,
  Alert,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Scrollbar from "../components/scrollbar";
import CompetitionsTable from "src/components/competitions/CompetitionsTable";
import CompetitionDialog from "src/components/competitions/CompetitionDialog";
import { get, del } from "src/utils/networkUtils";

export default function CompetitionsPage() {
  const [loading, setLoading] = useState(false);
  const [competitions, setCompetitions] = useState(null);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useState(null);

  const loadCompetitions = () => {
    setLoading(true);
    setError(null);
    get(`/admin/competitions`)
      .then(function (response) {
        setCompetitions(response.competitions);
        setLoading(false);
      })
      .catch(function (error) {
        console.error("Error loading competitions:", error);
        setError("Failed to load competitions");
        setLoading(false);
      });
  };

  useEffect(() => {
    loadCompetitions();
  }, []);

  const handleEdit = (competition) => {
    setSelectedCompetition(competition);
    setDialogOpen(true);
  };

  const handleDelete = async (competition) => {
    if (window.confirm(`Are you sure you want to delete "${competition.name}"?`)) {
      try {
        await del(`/admin/competitions/${competition.competitionId}`);
        loadCompetitions(); // Reload the list
      } catch (error) {
        console.error("Error deleting competition:", error);
        setError("Failed to delete competition");
      }
    }
  };

  const handleAddNew = () => {
    setSelectedCompetition(null);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedCompetition(null);
  };

  const handleDialogSuccess = () => {
    setDialogOpen(false);
    setSelectedCompetition(null);
    loadCompetitions(); // Reload the list
  };

  return (
    <>
      <Helmet>
        <title> Competitions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Competitions
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddNew}
          >
            Add Competition
          </Button>
        </Stack>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Card>
          {competitions === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <CompetitionsTable
                competitions={competitions}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            </Scrollbar>
          )}
        </Card>
      </Container>

      <CompetitionDialog
        open={dialogOpen}
        competition={selectedCompetition}
        onClose={handleDialogClose}
        onSuccess={handleDialogSuccess}
      />
    </>
  );
}
